export default __webpack_public_path__ + "static/media/bathroom2-afterA-2048w.d22e6d8a.png";